// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.checker[data-v-53bef09f] {\n  display: inline-block;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 4px;\n  cursor: pointer;\n}\n.checker-rows[data-v-53bef09f] {\n  width: 120px;\n}\n.checker-icon[data-v-53bef09f] {\n  width: 32px;\n  height: 32px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
